import user from 'legacy/utils/user'

import { createMagicLinkHttpClient } from 'auth/infra/createMagicLinkHttpClient'

import { API_URL } from '../../infra/environment'
import { HttpClient } from '../../infra/http/HttpClient'
import { ShipmentTagRepository } from '../infra/ShipmentTagRepository'

type GetCarrierShipmentTagsDependencies = {
  repository: ShipmentTagRepository
}

export function getCarrierShipmentTagsFactory({ repository }: GetCarrierShipmentTagsDependencies) {
  return function getTagsImpl(config?: { signal?: AbortSignal }) {
    return repository.fetchCarrierShipmentTags(config)
  }
}

export function getCarrierShipmentTags(config?: { signal?: AbortSignal }) {
  const loggedinUrl = `${API_URL}api/v2/shipperguide/`
  const httpClient = user.isLoggedIn() ? new HttpClient(loggedinUrl) : createMagicLinkHttpClient()

  const repository = new ShipmentTagRepository({ httpClient })
  const get = getCarrierShipmentTagsFactory({ repository })

  return get(config)
}
